const isVet = (value, nextQuestion) => (value === false ? 'callNow' : nextQuestion)
const benefits = (value, nextQuestion) => (value === false ? 'callNow' : nextQuestion)
const reasonFor = (value, nextQuestion) => nextQuestion
const tried = (value, nextQuestion) => (value === false ? 'callVa' : nextQuestion)
const waitTime = (value, nextQuestion) => value === 'Wait time below 20 days' ? nextQuestion : 'jeffVetAppointment'
const visit = (value, nextQuestion) => value.includes('VA Healthcare Benefits') ? nextQuestion : 'appointmentForm'
const qualify = value => value === 'None Apply' ? 'noQualifyVa' : 'jeffVetAppointment'
const authorized = (value, nextQuestion) => value === 'Yes' ? 'jeffVetAppointment' : nextQuestion

const schedule = (value, nextQuestion) => {
  if (value === 'Not Sure') {
    return 'callNow'
  }
  if (value === 'No') {
    return 'thankYou'
  }
  return nextQuestion
}

const driveTime = (value, nextQustion, reason) => {
  if (value === 'Don\'t Know') {
    return 'callVa'
  }

  switch (reason) {
  case ('Primary Care'):
  case ('Mental Health Services'):
  case ('Other'): {
    if (value === 'Less than 30 min') {
      return nextQustion
    }
    if (value === 'Greater than 30 min but less than 60 min' || value === 'Greater than 60 min') {
      return 'jeffVetAppointment'
    }
    break
  }
  case ('Specialist'): {
    if (value === 'Less than 30 min' || value === 'Greater than 30 min but less than 60 min') {
      return nextQustion
    }
    if (value === 'Greater than 60 min') {
      return 'jeffVetAppointment'
    }
    break
  }
  default:
    break
  }

  return null
}

export const questionNav = (question, value, nextQuestion, extraData) => {
  switch (question) {
  case 'isVet':
    return isVet(value, nextQuestion)
  case 'benefits':
    return benefits(value, nextQuestion)
  case 'authorized':
    return authorized(value, nextQuestion)
  case 'reasonFor':
    return reasonFor(value, nextQuestion)
  case 'schedule':
    return schedule(value, nextQuestion)
  case 'visit':
    return visit(value, nextQuestion)
  case 'driveTime':
    return driveTime(value, nextQuestion, extraData)
  case 'tried':
    return tried(value, nextQuestion)
  case 'waitTime':
    return waitTime(value, nextQuestion)
  case 'qualify':
    return qualify(value)
  default:
    return ''
  }
}
